module.exports = __webpack_public_path__ + "img/pribor_servis.938efe9a.svg";